// extracted by mini-css-extract-plugin
module.exports = {"input":"DatePickerSelect_input__3TTKZ","select":"DatePickerSelect_select__2dPnE"};